import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Star } from "lucide-react";

const sections = [
  {
    title: "1. Titolare del trattamento",
    body: "Il titolare del trattamento dei dati è Star Edil srls, P. IVA 10426680962. Per qualsiasi richiesta relativa ai tuoi dati puoi scrivere a star.edil18@gmail.com oppure alla PEC fabio.tricomi@pec.it, o chiamare il +39 347 4532075.",
  },
  {
    title: "2. Dati raccolti",
    body: "Tramite il modulo di richiesta preventivo raccogliamo: nome e cognome, indirizzo email, numero di telefono, informazioni sull'intervento richiesto (tipo di lavoro, metratura, tempistiche, messaggio) ed eventuali allegati caricati volontariamente (foto o piantine). Non raccogliamo dati tramite cookie di profilazione.",
  },
  {
    title: "3. Finalità e base giuridica",
    body: "I dati sono trattati esclusivamente per rispondere alla tua richiesta di preventivo o informazioni e per ricontattarti in merito (art. 6, par. 1, lett. b GDPR — misure precontrattuali adottate su richiesta dell'interessato). Il conferimento dei dati contrassegnati come obbligatori è necessario per poterti rispondere; in mancanza non potremo dare seguito alla richiesta.",
  },
  {
    title: "4. Modalità di trattamento e conservazione",
    body: "I dati sono trattati con strumenti informatici adottando misure di sicurezza adeguate. Le richieste e gli eventuali allegati sono conservati per il tempo necessario a gestire la tua richiesta e comunque non oltre 24 mesi dall'ultimo contatto, salvo obblighi di legge o instaurazione di un rapporto contrattuale.",
  },
  {
    title: "5. Destinatari dei dati",
    body: "I dati non vengono ceduti né venduti a terzi. Possono venirne a conoscenza esclusivamente il personale autorizzato di Star Edil srls e i fornitori tecnici che ospitano il sito e i servizi email, in qualità di responsabili del trattamento.",
  },
  {
    title: "6. Diritti dell'interessato",
    body: "Ai sensi degli artt. 15-22 del GDPR hai diritto di ottenere l'accesso ai tuoi dati, la rettifica, la cancellazione, la limitazione del trattamento, la portabilità e di opporti al trattamento. Puoi esercitare i tuoi diritti scrivendo a star.edil18@gmail.com. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
  },
  {
    title: "7. Cookie",
    body: "Questo sito utilizza esclusivamente cookie e tecnologie di memorizzazione locale di natura tecnica, strettamente necessari al funzionamento del sito (es. memorizzazione della scelta espressa nel banner cookie e della sessione dell'area riservata). Non utilizziamo cookie di profilazione, di marketing o di tracciamento di terze parti. Per i cookie tecnici non è richiesto il consenso ai sensi della normativa vigente.",
  },
  {
    title: "8. Aggiornamenti",
    body: "La presente informativa può essere aggiornata. Ti invitiamo a consultare periodicamente questa pagina. Ultimo aggiornamento: giugno 2026.",
  },
];

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-ink text-foreground" data-testid="privacy-page">
      <header className="border-b border-white/10 bg-surface">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="privacy-logo-link">
            <Star className="w-5 h-5 text-gold fill-gold" strokeWidth={1} />
            <span className="font-oswald text-lg tracking-[0.25em] uppercase">
              Star <span className="text-gold">Edil</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="flex items-center gap-2 font-oswald uppercase text-xs tracking-[0.2em] text-muted-foreground hover:text-gold transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Torna al sito
          </Link>
        </div>
      </header>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        className="max-w-3xl mx-auto px-6 py-20 lg:py-28"
      >
        <p className="font-oswald text-gold uppercase tracking-[0.35em] text-sm mb-6">Privacy Policy</p>
        <h1 className="font-display text-3xl sm:text-4xl leading-tight mb-6" data-testid="privacy-title">
          Informativa sul trattamento dei <span className="text-gold italic">dati personali</span>
        </h1>
        <p className="text-muted-foreground leading-loose mb-14">
          Informativa resa ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 ("GDPR") agli utenti che
          interagiscono con il sito di Star Edil srls e inviano richieste tramite il modulo di preventivo.
        </p>

        <div className="flex flex-col gap-12">
          {sections.map((s) => (
            <section key={s.title} className="border-t border-white/10 pt-8" data-testid={`privacy-section-${s.title.charAt(0)}`}>
              <h2 className="font-oswald uppercase text-lg tracking-[0.12em] text-gold mb-4">{s.title}</h2>
              <p className="text-muted-foreground leading-loose text-base">{s.body}</p>
            </section>
          ))}
        </div>
      </motion.div>

      <footer className="border-t border-white/10 py-10">
        <p className="text-center text-xs text-muted-foreground/60 font-oswald uppercase tracking-[0.2em]">
          © 2018 Star Edil srls — P. IVA 10426680962
        </p>
      </footer>
    </main>
  );
}
